(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    
(function($) {
$('.half-slider').slick({
  accessibility: true,
  arrows: true,
  speed: 500,
  dots: false,
  fade: true,
  draggable: true,
  touchThreshold: 20,
  autoplay: true,
  autoplaySpeed: 9000,
  vertical: true,
  slidesToShow: 1,
  slidesToScroll: 1
});
$(document).ready(function() {

});
})(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drawer"]) return;
  try {
    

  fetchCart();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-section"]) return;
  try {
    

(function($) {
	$(document).ready(function() {
		$('.accordion .accordion-tab').first().addClass('active')
		$('.accordion .accordion-heading a').click(function(e) {
			e.preventDefault();
			$(this).closest('.accordion').find('.accordion-tab.active').removeClass('active');
			$(this).closest('.accordion-tab').addClass('active');
		});
	});
})(jQuery);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["half-slider-right"] && !Shopify.designMode) return;
  try {
    
(function($) {
$('.half-slider').slick({
  accessibility: true,
  arrows: true,
  speed: 500,
  dots: false,
  fade: true,
  draggable: true,
  touchThreshold: 20,
  autoplay: true,
  autoplaySpeed: 9000,
  vertical: true,
  slidesToShow: 1,
  slidesToScroll: 1
});
})(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["half-slider"] && !Shopify.designMode) return;
  try {
    
(function($) {
$('.half-slider').slick({
  accessibility: true,
  arrows: true,
  speed: 500,
  dots: false,
  fade: true,
  draggable: true,
  touchThreshold: 20,
  autoplay: true,
  autoplaySpeed: 9000,
  vertical: true,
  slidesToShow: 1,
  slidesToScroll: 1
});
})(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-home-4"] && !Shopify.designMode) return;
  try {
    
(function($) {
	$(document).ready(function() {
	$('.tile')
    // tile mouse actions
    .on('mouseover', function(){
      $(this).children('.photo').css({'transform': 'scale('+ $(this).attr('data-scale') +')'});
    })
    .on('mouseout', function(){
      $(this).children('.photo').css({'transform': 'scale(1)'});
    })
    .on('mousemove', function(e){
      $(this).children('.photo').css({'transform-origin': ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '% ' + ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +'%'});
    })
    // tiles set up
    .each(function(){
      $(this)
        // add a photo container
        .append('<div class="photo"></div>')
        .children('.photo').css({'background-image': 'url('+ $(this).attr('data-image') +')'});
    });


	});
})(jQuery);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-main-section"]) return;
  try {
    

(function($) {
	$(document).ready(function() {
		$('.accordion .accordion-tab').first().addClass('active')
		$('.accordion .accordion-heading a').click(function(e) {
			e.preventDefault();
			$(this).closest('.accordion').find('.accordion-tab.active').removeClass('active');
			$(this).closest('.accordion-tab').addClass('active');
		});
	});
})(jQuery);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
(function($) {
$('.testimonials-slider').slick({
  accessibility: true,
  arrows: true,
  speed: 500,
  dots: false,
  fade: true,
  draggable: true,
  touchThreshold: 20,
  autoplay: true,
  autoplaySpeed: 9000,
  slidesToShow: 1,
  slidesToScroll: 1
});
$(document).ready(function() {

});
})(jQuery);

  } catch(e) { console.error(e); }
})();
})();
